import { ChatLauncher } from "@loot-os/design-system/domain/chat/ChatLauncher";

import { setChatOpen, useChatHeadcount, useChatOpen } from "../../lib/chat.js";

/**
 * The header's way into chat on a wide screen, with who's online once the room has answered. A
 * phone opens chat from the tab bar instead, so it is hidden there.
 */
export function StoreChatLauncher() {
  const open = useChatOpen();
  const headcount = useChatHeadcount();
  return (
    <ChatLauncher
      label="Chat"
      online={
        headcount === undefined
          ? undefined
          : { count: headcount.toLocaleString(), label: `${headcount.toLocaleString()} online` }
      }
      open={open}
      onClick={() => setChatOpen(!open)}
      className="max-md:hidden"
    />
  );
}
